import {WdiTable} from '@/components/WdiControls/WdiTable';
import React, {useState} from 'react';
import {WdiCardTitle, wdiCore, WdiModalProps} from '@/components/WdiControls';
import {Enum} from '@/enums/system';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Button, message} from 'antd';
import FormSaMktDetailAllocateMonthEditApp from '@/pages/mkt/sa/MktApply/components/DetailAllocateEdit';
import {addAllocateAmount} from "@/pages/mkt/sa/components/data";

export type FormSaMktAllocateProps = {
  dataSource: any[],
  onChange?: (dataSource: any) => void;
  activityStartDate?: Date;
  activityEndDate?: Date;
  readonly?: boolean;
  detailDataSource?: any[];
};

const FormSaMktDetailAllocateMonthApp: React.FC<FormSaMktAllocateProps> = (props: FormSaMktAllocateProps) => {

  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false, data: {datasource: []}});
  const {dataSource, onChange, activityStartDate, activityEndDate, detailDataSource} = props;

  const columns = [
    {
      title: '年月',
      key: 'ym',
      dataIndex: 'ym',
      width: 560,
    },
    {
      title: '分摊比例',
      key: 'shareRate',
      dataIndex: 'shareRate',
      width: 160,
      render: (text: any, row: any, index: any) => {
        return wdiCore.Number.RateToString(text, 4);
      },
    },
    {
      title: '分摊金额',
      key: 'amountMonth',
      dataIndex: 'amountMonth',
      width: 160,
      render: (text: any) => wdiCore.Number.AmountToString(text),
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark',
      ellipsis: true,

    }
  ];

  return (
    <>
      {modalProps.visible &&
        <FormSaMktDetailAllocateMonthEditApp
          {...modalProps}
          onSave={(responseResult) => {
            const newDataSource = addAllocateAmount(responseResult?.data, detailDataSource, 'shareRate');
            onChange?.(newDataSource);
            setModalProps({visible: false, data: null});
          }}
          onClose={() => setModalProps({visible: false, data: null})}
        />
      }
      <WdiPanel
        title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title={'月分摊信息'}/>}
        collapsed={false}
        extra={
          <Button hidden={props.readonly} type='primary' onClick={() => {
            if (!activityStartDate || !activityEndDate) {
              message.error('请先填写活动期间');
              return;
            }
            setModalProps({
              visible: true,
              title: '月份分摊比例',
              data: {
                dataSource: dataSource,
                activityStartDate: activityStartDate,
                activityEndDate: activityEndDate,
                detailDataSource: detailDataSource,
              },
            });
          }}>
            设置月份分摊
          </Button>
        }
      >
        <WdiTable
          pagination={false}
          columns={columns}
          dataSource={dataSource}
          aggrColumns={[{
            columnName: 'shareRate',
            formatter: ((result: any) => wdiCore.Number.RateToString(result, 4)),
          }, 'amountMonth']}
        />
      </WdiPanel>
    </>
  );
};

export default FormSaMktDetailAllocateMonthApp;

